// extracted by mini-css-extract-plugin
module.exports = {"content":"NotificationError_content__2Hyqa","title":"NotificationError_title__ArLV1","comment":"NotificationError_comment__1k_Y-"};